import React from "react";
import { Row, Col } from "reactstrap";

import { SearchBox } from "../SearchBox";

const ListingHeader = ({ title = "", onSearchChange = () => {}, searchedText = "" }) => {
    return (
        <>
            <Row>
                <Col sm="12" md="3" lg="3">
                    <SearchBox className="me-3" value={searchedText} onChange={onSearchChange} />
                </Col>
                <Col sm="12" md="9" lg="9">
                    <h6 className="mb-0 fw-600">{title}</h6>
                </Col>
            </Row>
        </>
    );
};

export default ListingHeader;
